import axios from 'axios';
import { ApiError } from './error';

export const consumeMagicLoginToken = token => {
  return axios
    .post(`/api/v1/magic-login/${token}/consume`)
    .then(res => res.data.data)
    .catch(ApiError.ofAndThrow);
};
